export default function () {
    const $infocard = document.querySelectorAll('.ce__isnack-infocard-teaser-action-btn');

    if (!$infocard.length) {
        return;
    }

    const infocardBtnAction = (id) => {
        const animate = 'bi-plus-lg-animate';
        const itemSelf = document.querySelector('#' + id);
        const iconSelf = document.querySelector('#' + id + ' .ce__isnack-infocard-teaser-btn .bi');
        if (!itemSelf.classList.contains('ce__isnack-infocard-teaser-active')) {
            Array.from(document.querySelectorAll('.ce__isnack-infocard-teaser-wrapper')).forEach((item) => {
                item.classList.remove('ce__isnack-infocard-teaser-active');
            });
            itemSelf.classList.add('ce__isnack-infocard-teaser-active');

            Array.from(document.querySelectorAll('.ce__isnack-infocard-teaser-btn .bi')).forEach((item) => {
                // item.classList.add('bi-plus-lg');
                // item.classList.remove('bi-dash-lg');
                item.classList.remove(animate);
            });

            // iconSelf.classList.add('bi-dash-lg');
            // iconSelf.classList.remove('bi-plus-lg');
            iconSelf.classList.add(animate);
        } else {
            itemSelf.classList.remove('ce__isnack-infocard-teaser-active');

            // iconSelf.classList.add('bi-plus-lg');
            // iconSelf.classList.remove('bi-dash-lg');
            iconSelf.classList.remove(animate);
        }
    };

    for (let i = 0; i < $infocard.length; i++) {
        const btn = $infocard[i];
        btn.onclick = function btnclick() {
            // eslint-disable-next-line prefer-destructuring
            const id = this.dataset.id;
            infocardBtnAction(id);
            return false;
        };
    }

    // add equal height to boxes, if some images have other ratios as expected
    /*
    removed eqh. set box height throught img ratio "3:2". if a svg will crash this, solve the problem by content request with svg viewbox 3:2.
    */
}
